import React from "react";
import { Button } from "@vitalsource/vstui";
import { t } from "../../../../core/translate";
import {
  shouldShowReadOffline,
  downloadApp
} from "../../../../utils/read-offline";
import { InstallNative, ExploreFeatures } from "./styles";
import { Clients } from "./icons";

export default () =>
  shouldShowReadOffline() ? (
    <InstallNative>
      <ExploreFeatures>
        {t(
          "header.mobile-menu.explore-features",
          "Explore even more features on our mobile app!"
        )}
      </ExploreFeatures>
      <Clients />
      <Button fullWidth onClick={downloadApp} style={{ marginTop: "23px" }}>
        {t("header.mobile-menu.install", "Install")}
      </Button>
    </InstallNative>
  ) : null;
